import SvgCommonStar, { starStatus } from "./SvgCommonStar";
interface Props {
  rate: number;
  large?: boolean;
  small?: boolean;
}
const ProductStars: React.FC<Props> = ({ rate, large, small }) => {
  return (
    <div>
      {[...Array(5)].map((_, i) => (
        <SvgCommonStar
          key={i}
          {...starStatus(i, rate)}
          large={large}
          small={small}
        />
      ))}
    </div>
  );
};

export default ProductStars;
